import axiosInstance from "../utils/ApiUtils/axiosInstance";

export type ExportTranslationMode = "full" | "pending";

export type ExportTranslationParams = {
  translationId: number;
  mode?: ExportTranslationMode;
};

export type ExportedTranslationFile = {
  blob: Blob;
  filename: string;
};

export const exportTranslation = async ({
  translationId,
  mode = "full",
}: ExportTranslationParams): Promise<ExportedTranslationFile> => {
  const response = await axiosInstance.get(`/api/translation/${translationId}/export`, {
    params: { mode },
    responseType: "blob",
  });

  // Prefer the server-provided filename from Content-Disposition, otherwise fall back.
  const contentDisposition = response.headers["content-disposition"] as string | undefined;
  let filename = `translation-${translationId}.tsv`;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?"?([^"';]+)"?/i);
    if (match?.[1]) {
      filename = decodeURIComponent(match[1]);
    }
  }

  return { blob: response.data as Blob, filename };
};
